import React from 'react';
import PropTypes from 'prop-types';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {AutoSuggestSelect} from 'components/common';
import {fetchUsers} from 'api';
import * as validators from 'utils/validators';
import {makeForm, buildUserFullName} from 'utils/common';

class TeacherAdditionForm extends React.Component {
  static propTypes = {
    schoolId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.fetchTeachers = this.fetchTeachers.bind(this);
  }

  fetchTeachers(value) {
    const {schoolId} = this.props;
    return fetchUsers(value, undefined, undefined, undefined, {
      schoolId,
      role: 'teacher',
      includeNotActivated: true,
    }).then(({records}) =>
      records.map((record) => ({
        id: record.id,
        name: buildUserFullName(record, true, true),
      })),
    );
  }

  render() {
    const {handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <AutoSuggestSelect
              name="teachers"
              label="Teachers"
              labelKey="name"
              valueKey="id"
              multi
              onSearch={this.fetchTeachers}
              required
              validate={[validators.isRequired]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Add
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default makeForm(TeacherAdditionForm, 'TeacherAdditionForm.Update', null, null);
